const sar = {
  newSar: 'New SAR',
  newStep1: 'Step 1: Choose the user to file a SAR',
  newStep2: 'Step 2: Choose the counterpart of SAR',
  newStep3: 'Step 3: Choose the anomaly type',
  newStep4: 'Step 4: Manage the effects of the SAR',
  newStep5: 'Step 5: Issue the Suspicious Activity Report',
  reasonForSuspicion: 'Reason for suspicion',
  suspiciousActivitiesReport: 'Suspicious Activities Report',
};

export default sar;
